import React from 'react';

const WorksheetTabs = ({ worksheets, activeWorksheetId, onSelectWorksheet }) => {
  return (
    <div className="worksheet-tabs flex border-b border-gray-300 mb-4">
      {worksheets.map((worksheet) => (
        <button
          key={worksheet.id}
          className={`px-4 py-2 font-medium text-sm ${
            worksheet.id === activeWorksheetId
              ? 'border-b-2 border-blue-500 text-blue-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
          onClick={() => onSelectWorksheet(worksheet.id)}
        >
          {worksheet.name}
        </button>
      ))}
    </div>
  );
};

export default WorksheetTabs;